module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyt",
    attrs: {
      "id": "cop"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("This book is a publication of")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Indiana University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Office of Scholarly Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Herman B Wells Library 350")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1320 East 10th Street")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Bloomington, Indiana 47405 USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://iupress.indiana.edu",
      "target": "_blank"
    }
  }, [_vm._v("iupress.indiana.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© 2020 by Indiana University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("No part of this book may be reproduced or utilized in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage and retrieval system, without permission in writing from the publisher. The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1992.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cataloging information is available from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978-0-253-04690-1 (hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-0-253-04691-8 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-0-253-04694-9 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("1 2 3 4 5     25 24 23 22 21 20")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657d1c73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_Yob_and_Jorgensen_fm_prod0c.vue
// module id = 69
// module chunks = 0